<div class="button-list-container map-floating-button">
  <button mat-icon-button color="primary" class="wtr-button-primary" (click)="toggleLock()">
    <mat-icon [svgIcon]="isLocked ? 'grid-selection-off' : 'grid-selection'"></mat-icon>
  </button>
</div>
